import type { ModuleOptions } from '#cookie-control/types'

export default {
  "barPosition": "bottom-full",
  "closeModalOnClickOutside": true,
  "colors": {
    "barBackground": "#000",
    "barButtonBackground": "#fff",
    "barButtonColor": "#000",
    "barButtonHoverBackground": "#333",
    "barButtonHoverColor": "#fff",
    "barTextColor": "#fff",
    "checkboxActiveBackground": "#000",
    "checkboxActiveCircleBackground": "#fff",
    "checkboxDisabledBackground": "#ddd",
    "checkboxDisabledCircleBackground": "#fff",
    "checkboxInactiveBackground": "#000",
    "checkboxInactiveCircleBackground": "#fff",
    "controlButtonBackground": "#fff",
    "controlButtonHoverBackground": "#000",
    "controlButtonIconColor": "#000",
    "controlButtonIconHoverColor": "#fff",
    "focusRingColor": "#808080",
    "modalBackground": "#fff",
    "modalButtonBackground": "#000",
    "modalButtonColor": "#fff",
    "modalButtonHoverBackground": "#333",
    "modalButtonHoverColor": "#fff",
    "modalOverlay": "#000",
    "modalOverlayOpacity": 0.8,
    "modalTextColor": "#000",
    "modalUnsavedColor": "#fff"
  },
  "cookies": {
    "necessary": [
      {
        "description": {
          "en": "This cookie stores preferences.",
          "de": "Dieser Cookie speichert Einstellungen."
        },
        "id": "p",
        "name": {
          "en": "Preferences",
          "de": "Einstellungen"
        }
      },
      {
        "description": {
          "en": "This cookie stores your cart.",
          "de": "Dieser Cookie speichert den Warenkorb."
        },
        "id": "p",
        "name": {
          "en": "Cart",
          "de": "Warenkorb"
        }
      },
      {
        "description": {
          "en": "This coockie stores the login status. To not have to login again everytime the pages opens.",
          "de": "Dieser Cookie speichert den Login-Status um sich nicht jedes Mal neu anmelden zu müssen."
        },
        "id": "p",
        "name": {
          "en": "Login",
          "de": "Login"
        }
      }
    ],
    "optional": [
      {
        "id": "meta-pixel",
        "name": {
          "de": "Meta Pixel (Facebook Pixel)",
          "en": "Meta Pixel"
        },
        "description": {
          "de": "Wird verwendet, um Besucheraktionen auf der Website zu analysieren und Werbekampagnen auf Facebook zu optimieren.",
          "en": "Used to analyze visitor behavior and optimize Facebook ad campaigns."
        },
        "targetCookieIds": [
          "_fbp"
        ]
      },
      {
        "id": "ga",
        "name": {
          "en": "Google Analytics",
          "de": "Google Analytics"
        },
        "description": {
          "en": "Helps us understand how users interact with the website.",
          "de": "Hilft uns zu verstehen, wie Nutzer die Website verwenden."
        }
      },
      {
        "id": "hotjar",
        "name": {
          "de": "Hotjar"
        },
        "description": {
          "de": "Hotjar hilft uns zu verstehen, wie Besucher unsere Website nutzen (z. B. durch Heatmaps, Umfragen und Nutzeraufzeichnungen)."
        }
      }
    ]
  },
  "cookieExpiryOffsetMs": 31536000000,
  "cookieNameIsConsentGiven": "ncc_c",
  "cookieNameCookiesEnabledIds": "ncc_e",
  "cookieOptions": {
    "path": "/"
  },
  "isAcceptNecessaryButtonEnabled": true,
  "isControlButtonEnabled": true,
  "isCookieIdVisible": false,
  "isCssEnabled": true,
  "isCssPonyfillEnabled": false,
  "isDashInDescriptionEnabled": true,
  "isIframeBlocked": false,
  "isModalForced": false,
  "locales": [
    "en",
    "de",
    "en"
  ],
  "localeTexts": {
    "en": {
      "accept": "Accept",
      "acceptAll": "Accept all",
      "bannerDescription": "We use our own cookies and third-party cookies so that we can display this website correctly and better understand how this website is used, with a view to improving the services we offer. A decision on cookie usage permissions can be changed anytime using the cookie button that will appear after a selection has been made on this banner.",
      "bannerTitle": "Cookies",
      "close": "Close",
      "cookiesFunctional": "Functional cookies",
      "cookiesNecessary": "Necessary cookies",
      "cookiesOptional": "Optional cookies",
      "decline": "Decline",
      "declineAll": "Decline all",
      "here": "here",
      "iframeBlocked": "To see this, please enable functional cookies",
      "manageCookies": "Learn more and customize",
      "save": "Save",
      "settingsUnsaved": "You have unsaved settings"
    },
    "de": {
      "accept": "Akzeptieren",
      "acceptAll": "Alle akzeptieren",
      "bannerDescription": "Wir verwenden eigene Cookies und Cookies von Drittanbietern, damit wir diese Webseite korrekt darstellen können und besser verstehen, wie diese Webseite genutzt wird, um unser Angebot zu verbessern. Eine Entscheidung über die Erlaubnis zur Verwendung von Cookies kann jederzeit über den Cookie-Button geändert werden, der erscheint, nachdem eine Auswahl auf diesem Banner getroffen wurde.",
      "bannerTitle": "Cookies",
      "close": "Schließen",
      "cookiesFunctional": "Funktionale Cookies",
      "cookiesNecessary": "Notwendige Cookies",
      "cookiesOptional": "Optionale Cookies",
      "decline": "Ablehnen",
      "declineAll": "Alle ablehnen",
      "here": "hier",
      "iframeBlocked": "Um den Inhalt zu sehen, aktivieren Sie bitte funktionale Cookies",
      "manageCookies": "Mehr erfahren und anpassen",
      "save": "Speichern",
      "settingsUnsaved": "Es gibt nicht gespeicherte Einstellungen"
    }
  }
} as ModuleOptions